import { cn } from "@/lib/cn";

/** Liga/desliga com rótulo e descrição; a linha inteira é clicável (bom no toque). */
export function Interruptor({
  ligado,
  onMudar,
  rotulo,
  descricao,
  disabled,
}: {
  ligado: boolean;
  onMudar: (v: boolean) => void;
  rotulo: string;
  descricao?: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligado}
      disabled={disabled}
      onClick={() => onMudar(!ligado)}
      className="flex w-full items-start justify-between gap-4 rounded-lg py-2 text-left disabled:opacity-50"
    >
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-neutral-900">{rotulo}</span>
        {descricao && (
          <span className="mt-0.5 block text-[13px] text-neutral-500">{descricao}</span>
        )}
      </span>
      <span
        aria-hidden
        className={cn(
          "relative mt-0.5 h-6 w-10 shrink-0 rounded-full transition-colors duration-200",
          ligado ? "bg-gold-500" : "bg-neutral-300",
        )}
      >
        <span
          className={cn(
            "absolute top-0.5 size-5 rounded-full bg-white shadow-sm transition-transform duration-200",
            ligado ? "translate-x-[18px]" : "translate-x-0.5",
          )}
        />
      </span>
    </button>
  );
}
